import { render, staticRenderFns } from "./SwitchMigracaoSimplificadaField.vue?vue&type=template&id=2f6db3d2&scoped=true&"
import script from "./SwitchMigracaoSimplificadaField.vue?vue&type=script&lang=js&"
export * from "./SwitchMigracaoSimplificadaField.vue?vue&type=script&lang=js&"
import style0 from "./SwitchMigracaoSimplificadaField.vue?vue&type=style&index=0&id=2f6db3d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f6db3d2",
  null
  
)

export default component.exports